import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface WithdrawCheckingExpiredProps {
  store: WithdrawStore
}

export const WithdrawCheckingExpired = observer(({ store }: WithdrawCheckingExpiredProps) => {
  return (
    <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodySM className="text-t200">Checking if your veSCALE has expired...</BodySM>
    </ShortMessageBox>
  )
})

